import {observer} from 'mobx-react-lite'
import React, {Fragment, useContext, useEffect, useState} from 'react'
import {Store} from '../../../app/stores/store-root'
import {
    EuiComboBox,
    EuiDescribedFormGroup,
    EuiFieldText,
    EuiFormRow,
    EuiLink,
    EuiPanel,
    EuiTextArea
} from '@elastic/eui';
import {useFormikContext} from "formik";

type PersonalInformationProps = {
    onCountryChange: (countryCode: string) => void,
    submitting: boolean
}
const PersonalInformation = ({onCountryChange, submitting}: PersonalInformationProps) => {
    const store = useContext(Store);
    const formik = useFormikContext();

    const [selectedOptions, setSelectedOptions] = useState<any[]>([])

    useEffect(() => {
        if (formik.getFieldProps('Country').value) {

            const country = store.Lookups.countryRegistry.find(item => item.label === formik.getFieldProps('Country').value);
            console.log(country)
            setSelectedOptions([{
                key: country!.key,
                value: country!.value,
                label: country!.label
            }]);
        }


    }, [formik])

    return (
        <Fragment>
            <EuiPanel>
                <EuiDescribedFormGroup title={<h3>Personal Information</h3>}
                                       description={
                                           <Fragment>
                                               Please use the + instead of 00 for the phone numbers and include international dialing code.

                                               <p>when the profile is created please provide the user with the automatically generated username and temp password if they dont have access to email. The application will force them to reset their password when signing in.</p    >
                                           </Fragment>
                                       }>
                    <EuiFormRow label='Name'
                                isInvalid={((formik.getFieldMeta('Name').error) && (formik.getFieldMeta('Name').touched)) ? true : false}
                                error={formik.getFieldMeta('Name').error}>
                        <EuiFieldText {...formik.getFieldProps('Name')} disabled={submitting}
                                      isInvalid={((formik.getFieldMeta('Name').error) && (formik.getFieldMeta('Name').touched)) ? true : false}/>
                    </EuiFormRow>
                    <EuiFormRow label='Family Name'
                                isInvalid={((formik.getFieldMeta('FamilyName').error) && (formik.getFieldMeta('FamilyName').touched)) ? true : false}
                                error={formik.getFieldMeta('FamilyName').error}>
                        <EuiFieldText {...formik.getFieldProps('FamilyName')} disabled={submitting}
                                      isInvalid={((formik.getFieldMeta('FamilyName').error) && (formik.getFieldMeta('FamilyName').touched)) ? true : false}
                        />
                    </EuiFormRow>
                    <EuiFormRow label='Phone'
                                isInvalid={((formik.getFieldMeta('Phone').error) && (formik.getFieldMeta('Phone').touched)) ? true : false}
                                error={formik.getFieldMeta('Phone').error}>
                        <EuiFieldText {...formik.getFieldProps('Phone')} disabled={submitting}
                                      isInvalid={((formik.getFieldMeta('Phone').error) && (formik.getFieldMeta('Phone').touched)) ? true : false}/>
                    </EuiFormRow>
                    <EuiFormRow label='Email Address'
                                isInvalid={((formik.getFieldMeta('Email').error) && (formik.getFieldMeta('Email').touched)) ? true : false}
                                error={formik.getFieldMeta('Email').error}>
                        <EuiFieldText {...formik.getFieldProps('Email')} disabled={submitting}
                                      isInvalid={((formik.getFieldMeta('Email').error) && (formik.getFieldMeta('Email').touched)) ? true : false}/>
                    </EuiFormRow>
                    <EuiFormRow label='Country'
                                isInvalid={((formik.getFieldMeta('Country').error) && (formik.getFieldMeta('Country').touched)) ? true : false}
                                error={formik.getFieldMeta('Country').error}>
                        <EuiComboBox {...formik.getFieldProps('Country')}
                                     options={store.Lookups.countries}
                                     selectedOptions={selectedOptions}
                                     singleSelection={{asPlainText: true}}
                                     isDisabled={submitting}
                                     isInvalid={((formik.getFieldMeta('Country').error) && (formik.getFieldMeta('Country').touched)) ? true : false}

                                     onChange={(items) => {
                                         console.log(items);
                                         if (!items || items.length === 0) {
                                             setSelectedOptions([]);
                                             formik.getFieldHelpers('CountryCode').setValue(undefined);
                                             formik.getFieldHelpers('Country').setValue(undefined);
                                             return;
                                         }
                                         setSelectedOptions(items);
                                         const id = items[0].value;
                                         const label = items[0].label;
                                         console.log(id);
                                         formik.getFieldHelpers('CountryCode').setValue(id);
                                         formik.getFieldHelpers('Country').setValue(label);
                                         console.log('suggested username ', id?.toUpperCase() + "-" + store.generateRandom());
                                         if (!formik.getFieldProps('UserName').value)
                                             formik.getFieldHelpers('UserName').setValue(id?.toUpperCase() + "-" + store.generateRandom());


                                         const currency = store.Lookups.countryRegistry.find((item) => item.key === id);
                                         console.log('Found Currency ', currency)
                                         if (currency) {
                                             formik.getFieldHelpers('CurrencyCode').setValue(currency.currencyCode);
                                             formik.getFieldHelpers('CurrencySymbol').setValue(currency.currencySymbol);
                                             formik.getFieldHelpers('CurrencyLabel').setValue(currency.currencyLabel);
                                         }
                                         onCountryChange(id ?? '');
                                     }
                                     }/>
                    </EuiFormRow>
                    <EuiFormRow label='City'
                                isInvalid={((formik.getFieldMeta('City').error) && (formik.getFieldMeta('City').touched)) ? true : false}
                                error={formik.getFieldMeta('City').error}>
                        <EuiFieldText {...formik.getFieldProps('City')} disabled={submitting}
                                      isInvalid={((formik.getFieldMeta('City').error) && (formik.getFieldMeta('City').touched)) ? true : false}/>
                    </EuiFormRow>
                    <EuiFormRow label='Address'
                                isInvalid={((formik.getFieldMeta('Address').error) && (formik.getFieldMeta('Address').touched)) ? true : false}
                                error={formik.getFieldMeta('Address').error}>
                        <EuiTextArea {...formik.getFieldProps('Address')} disabled={submitting}
                                     isInvalid={((formik.getFieldMeta('Address').error) && (formik.getFieldMeta('Address').touched)) ? true : false}/>
                    </EuiFormRow>
                </EuiDescribedFormGroup>
            </EuiPanel>
            {/*<div className="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                <div className="md:grid md:grid-cols-3 md:gap-6">
                    <div className="md:col-span-1">
                        <h3 className="text-lg font-medium leading-6 text-gray-900">
                            Personal Information
                        </h3>
                        <p className="mt-1 text-sm leading-5 text-gray-500">
                            Use a permanent address where you can receive mail.
                        </p>
                    </div>
                    <div className="mt-5 md:mt-0 md:col-span-2">
                        <form action="#" method="POST">
                            <div className="grid grid-cols-4 gap-6">
                                <div className="col-span-4 sm:col-span-2">
                                    <label
                                        htmlFor="name"
                                        className="block text-sm font-medium leading-5 text-gray-700"
                                    >
                                        Name
                                    </label>
                                    <TextInput id='Name' placeholder='e.g yyyyy'/>
                                </div>
                                <div className="col-span-4 sm:col-span-2">
                                    <label
                                        htmlFor="FamilyName"
                                        className="block text-sm font-medium leading-5 text-gray-700"
                                    >
                                        Family Name
                                    </label>
                                    <TextInput id='FamilyName' placeholder='e.g xxxxx'/>
                                </div>
                                <div className="col-span-4 sm:col-span-2">
                                    <label
                                        htmlFor="Phone"
                                        className="block text-sm font-medium leading-5 text-gray-700"
                                    >
                                        Phone
                                    </label>
                                    <TextInput id='Phone' placeholder='e.g +44 07475305514'/>
                                </div>
                                <div className="col-span-4 sm:col-span-2">
                                    <label
                                        htmlFor="Email"
                                        className="block text-sm font-medium leading-5 text-gray-700"
                                    >
                                        Email address
                                    </label>
                                    <TextInput id='Email' placeholder='e.g salih@getnada.com'/>
                                </div>

                                <div className="col-span-4 sm:col-span-2">
                                    <label
                                        htmlFor="CountryCode"
                                        className="block text-sm font-medium leading-5 text-gray-700"
                                    >
                                        Country
                                    </label>
                                    <CountrySelector name='Country' options={store.Lookups.countries}
                                                     label='Select agents country'/>
                                </div>
                                <div className="col-span-4 sm:col-span-2">
                                    <CitySelector name='City'/>
                                </div>
                                <div className="col-span-4">
                                    <label
                                        htmlFor="street_address"
                                        className="block text-sm font-medium leading-5 text-gray-700"
                                    >
                                        Address
                                    </label>
                                    <TextArea id='Address'/>
                                </div>
                                <div className="col-span-4 sm:col-span-2">
                                    <label
                                        htmlFor="name"
                                        className="block text-sm font-medium leading-5 text-gray-700"
                                    >
                                        Temprory password
                                    </label>

                                    <TextInput id='Password' placeholder='Temprory password sent to the user'/>
                                </div>
                                <div className="col-span-4 sm:col-span-2">
                                    <label
                                        htmlFor="name"
                                        className="block text-sm font-medium leading-5 text-gray-700"
                                    >
                                        User Profile Id - Read Only for admin use
                                    </label>

                                    <TextInput id='Id' placeholder='User Profile Id - Automatically Generated'
                                               disabled={true}/>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
*/}
        </Fragment>
    )
}

export default observer(PersonalInformation);
